import style from "./NavBarList.module.css";

const NavBarList = (props) => {

  const navlist = ["Home", "About", "Contact", "Blog", "Careers"];

  return (
    <ul
      className={
        !props.isHidden ? style.navButtonContainer : style.navContainer
      }
    >
      {navlist.map((e) => (
        <li className={style.navList} key={e}>
          <a href="google.com" className={style.navLink}>
            {e}
          </a>
        </li>
      ))}
    </ul>
  );
};

export default NavBarList;
